import React from 'react';
import styled from 'styled-components';
import mainbackground from '../../assets/images/background/mainbackground.png';
import SplashLogo from '../../assets/images/logo/splashlogo.png';

const SplashContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #121212; /* Tema rengine uygun */
  color: white;
  font-size: 24px;
  font-weight: bold;
`;

const SplashContent = styled.div`
  width: 100%;
  height: 100%;
  max-width: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`
const SplashBackground = styled.img`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: fill;
    `
const Logo = styled.img`
    width: 100%;
    max-width: 320px;
    z-index: 1;
`

const SplashScreen = () => {
  return (
    <SplashContainer>
      <SplashContent>
        <SplashBackground src={mainbackground} alt="Main Background" />
          <Logo src={SplashLogo} alt="Splash Logo" />
      </SplashContent>
    </SplashContainer>
  );
};

export default SplashScreen;
